import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type SkeletonGroupsWrapperProps = {
    $isNavBar: boolean;
    $isNoSuggestions?: boolean;
};

export const SkeletonGroupsWrapper = styled.div<SkeletonGroupsWrapperProps>`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('400')};
    width: 100%;
    padding: ${({ $isNoSuggestions }) =>
        $isNoSuggestions ? 0 : `${getPurpurSpacing('300')} ${getPurpurSpacing('200')}`};

    ${({ $isNavBar }) =>
        $isNavBar &&
        purpurMedia('lg')`
            flex-direction: row;
            gap: ${getPurpurSpacing('600')};
        `};

    ${({ $isNoSuggestions }) => purpurMedia('lg')`
        padding: ${$isNoSuggestions ? 0 : getPurpurSpacing('400')}
    `};
`;

export const PopularQueriesSkeletonWrapper = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};
`;

export const AutoCompleteSkeletonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const AutoCompleteItemSkeleton = styled(Skeleton)`
    width: 15rem;
    height: 1.5rem;
`;

export const ProductCardSkeleton = styled(Skeleton)`
    width: 100%;
    height: 8.25rem;
`;

export const QueryButtonSkeleton = styled(Skeleton)`
    width: 7.5rem;
    height: 2.625rem;
`;
